import { render, staticRenderFns } from "./infoSmallCountTo.vue?vue&type=template&id=6f13e688&"
import script from "./infoSmallCountTo.vue?vue&type=script&lang=js&"
export * from "./infoSmallCountTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports